import { render, staticRenderFns } from "./RoundAlertDialog.vue?vue&type=template&id=1c26cafd&"
import script from "./RoundAlertDialog.vue?vue&type=script&lang=js&"
export * from "./RoundAlertDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports